import axios from "axios";

export default function tokenInterceptor(token: string): void {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}
